import { generateUnOrderedList } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc66 = {
    title: "Image 66: Accessible Seating Ratios.",
    para1: <>
        <p>The image shows a table that shows the number of seats required in a seating area and the number of wheelchair-accessible spaces that should be provided. It is adopted from the Harmonised Guidelines 2021. </p>
        <p>The table has two columns with headings: "NUMBER OF SEATS IN A SEATING AREA", and "NUMBER OF REQUIRED SPACES FOR WHEELCHAIR USERS".
        </p>
        <p>The rows in the table specify the maximum number of seats in a seating area. The corresponding number of wheelchair-accessible spaces required is specified in the next column. The breakdown of the table is as follows:
            <div className="figure_desc">
                {generateUnOrderedList([
                    "Up to 600 seats: 6 , i.e., 1 per 100 seats",
                    "Up to 1000 seats: 6 + 2",
                    "Over 1000 seats: 8 + 1 additional space for every additional 1000 seats",
                ])}
            </div>
        </p>
    </>,
}

export const ImageDesc67 = {
    title: "Image 67: Example of a Video Conferencing Hall at the High Court of Odisha.",
    para1: "The image shows a Video Conferencing Hall at the High Court of Odisha. The room has a long table and chairs. The table is long and rectangular, with a smooth surface. It appears to be made of wood.  There are multiple chairs surrounding the table. They have black backs and seat cushions, and rolling casters on the feet. The table also has multiple screens to facilitate video conferencing. There is a painting of Mahatma Gandhi on one of the walls."
}

export const FigureDesc61 = {
    title: "Figure 61: Typical floor plan of a 10-person capacity Conference Room. ",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The figure shows a floor plan for a conference room with seating capacity for 10 persons. The entrance is located at the bottom right corner of the room.
        </p>
        <p>
            The features are described from right to left.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance to the conference room is located at the bottom-right corner of the layout.",
                    "At the top-right corner, a table and chair has been provided for the staff manning the conference room. The table is equipped with digital technology.",
                    "A conference table with 10-person seating capacity (including provision for wheelchair-accessible seating) is provided in the centre of the room. Four seats are provided on either side of the table, facing top and bottom, and single seats are provided at the left and right sides of the table. The table is equipped with digital technology, including computer systems and other IT facilities.",
                    "A projector is provided at the left side of the room, in such a manner that it is visible to all persons seated at the conference table.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc62 = {
    title: "Figure 62: Typical floor plan of a 25-person capacity Conference Room.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The figure shows a floor plan for a conference room with seating capacity for 25 persons. The entrance is located at the bottom right corner of the room.
        </p>
        <p>The features are described from right to left.</p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance to the conference room is located at the bottom-right corner of the layout.",
                    "At the top-right corner, a table and chair has been provided for the staff manning the conference room. The table is equipped with digital technology.",
                    "A conference table with 25-person seating capacity (including provision for wheelchair-accessible seating at the bottom-right and top-left corners of the table) is provided in the centre of the room. Ten seats are provided on either side of the table, facing top and bottom, and single seats are provided at the left and right sides of the table. The table is equipped with digital technology, including computer systems, mics and other IT facilities.",
                    "Two screens are provided at the top and bottom of the layout, in the centre of the table, for use by persons seated at the farther seats of the table. ",
                    "A projector is provided at the left side of the room, in such a manner that it is visible to all persons seated at the conference table.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc63 = {
    title: "Figure 63: Typical floor plan of a Training Room. ",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The figure shows a floor plan for a Training Room. Two entrances to the room are provided; one entrance is at the top-right of the layout, and the second entrance is at the bottom-right.
        </p>
        <p>
            The features of the room are described from top to bottom, starting from the entrance at the top-right.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "An entrance to the Training Room is provided at the top-right of the layout.",
                    "A projector is provided at the top-centre of the layout, such that it is visible to all persons using the room.",
                    "At the top-left, a table and chair have been provided for staff manning the computer screens and/or conducting the Training Sessions. The table is equipped with digital technology.",
                    "The room is occupied by five rows of three tables each, from top to bottom. Each of the tables contains seating provisions (including wheelchair-accessible seating) for two persons.",
                    "The desks are equipped with digital technology wherever needed.",
                    "Storage space is provided along the wall at the bottom of the layout. ",
                    "Next to the storage space, at the bottom-right of the layout, a second entrance door is provided. ",

                ])}
            </div>
        </p>
    </>
}



